/*
 * Application-wide presenters for confirmation, sign-in recovery and Code-of-Conduct dialogs.
 * Used once by the application shell so services can request a dialog from any route.
 * Keeping these presenters outside routes lets an accepted decision outlive its opener.
 * Example: registerComponents(registry);
 *          <AccountLayers context={context}/>
 */

import { registerComponents as registerDialogs, DialogLayer } from '../ui/dialogs.jsx';
import { registerComponents as registerRecovery, AuthRecoveryLayer } from './auth-recovery.jsx';
import { registerComponents as registerConsent, ConsentLayer } from './coc-modal.jsx';
import { registerComponents as registerPublicLogin } from './public-login.jsx';

export function registerComponents(registry) {
  registerDialogs(registry);
  registerRecovery(registry);
  registerConsent(registry);
  registerPublicLogin(registry);
}

export function AccountLayers({ context }) {
  return (
    <>
      <DialogLayer context={context}/>
      <AuthRecoveryLayer context={context}/>
      <ConsentLayer context={context}/>
    </>
  );
}
